const commonTabs = [
  {
    key: "dashboard",
    label: "Dashboard",
  },
  {
    key: "reporting",
    label: "Reporting",
  },
  {
    key: "tree",
    label: "Tree",
  },
  {
    key: "invites",
    label: "Invites",
  },
];

export { commonTabs };
